import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";

const NotFound = () => {
  return (
    <main className="not-found-page">
      <section className="not-found-content" aria-labelledby="not-found-title">
        <p className="not-found-kicker">404</p>
        <h1 id="not-found-title">Page Not Found</h1>
        <p>
          This Kynetic page is not available. Head back home, explore our
          services, or contact the team to get moving.
        </p>
        <div className="not-found-actions">
          <Link to="/" className="not-found-button primary">
            Go to homepage
          </Link>
          <Link to="/services" className="not-found-button">
            View services
          </Link>
          <Link to="/contact" className="not-found-button">
            Contact Kynetic
          </Link>
        </div>
      </section>
    </main>
  );
};

export default NotFound;
